export default {
    setToggleLikePost(state, payload) {
        const author = {
            user_id: localStorage.getItem('userId'),
            name: localStorage.getItem('name'),
            avatar: localStorage.getItem('avatar')
        }
        const postId = payload.postId;
        if (state.userLike[postId]) {
            if (state.userLike[postId].findIndex(user => user.user_id === author.user_id) === -1) {
                state.userLike[postId] = [
                    {
                        author: author,
                        post_id: postId,
                        user_id: author.user_id,
                    }
                ];
            } else {
                state.userLike[postId] = state.userLike[postId].filter(user => user.user_id !== author.user_id);
            }
        } else {
            state.userLike[postId] = [
                {
                    author: author,
                    post_id: postId,
                    user_id: author.user_id,
                }
            ];
        }
        if (state.cacheUserLike[postId]) {
            if (state.postLike[postId]) {
                state.postLike[postId].likes = state.postLike[postId].likes - 1;
            } else {
                state.postLike[postId] = { likes: state.postLike[postId].likes - 1 };
            }
            delete state.cacheUserLike[postId];
        } else {
            if (state.postLike[postId]) {
                state.postLike[postId].likes = state.postLike[postId].likes + 1;
            } else if (!state.postLike[postId]) {
                state.postLike[postId] = { likes: 1 };
            }
            state.cacheUserLike[postId] = state.userLike[postId];
        }
    },
    setAllUserLikePost(state, userLikePost) {
        const groupedByPostId = userLikePost.reduce((acc, user) => {
            if (!acc[user.post_id]) {
                acc[user.post_id] = [];
            }
            acc[user.post_id].push(user);
            return acc;
        }, {});
        state.userLike = groupedByPostId;
    },
    setPostLikes(state, postLikes) {
        for (let postId in postLikes) {
            state.postLike[postLikes[postId].post_id] = { likes: postLikes[postId].likes };
        }
    },
    setSpecificUserLikePost(state, postLikeByUser) {
        const groupedByPostId = postLikeByUser.reduce((acc, user) => {
            if (!acc[user.post_id]) {
                acc[user.post_id] = [];
            }
            acc[user.post_id].push(user);
            return acc;
        }, {});
        state.cacheUserLike = groupedByPostId;
    }
};